<template>
  <div :class="$style.container">
    <!-- -------------- -->
    <!-- PROFILE TOGGLE -->
    <!-- -------------- -->

    <div :class="$style.header">
      <NsHeaderProfileToggle
        :dropdown-open="dropdownOpen"
        :greeting="translations.greeting"
        :hide-sign-up="hideSignUp"
        :sign-in-label="translations.signIn"
        :sign-up-label="translations.signUp"
        @toggle="handleDropdownToggle"
      />

      <!-- CLOSE BUTTON -->
      <div :class="$style.closeButton" @click="handleCloseClick">
        <NsIcon
          :class="$style.closeIcon"
          icon-name="icon-close-24"
          size="custom"
          data-testid="profileDropdownMobileClose"
        />
      </div>
    </div>

    <!-- --------------- -->
    <!-- MOBILE DROPDOWN -->
    <!-- --------------- -->

    <NsAnimateHeight :open="dropdownOpen">
      <NsHeaderProfile
        :hide-sign-up="hideSignUp"
        :profile-menu="profileMenu"
        :sign-out-url="signOutUrl"
        :sign-up-url="signUpUrl"
        :translations="translations"
      />
    </NsAnimateHeight>
  </div>
</template>

<script>
import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon, NsAnimateHeight } from "@nuskin/design-components";

import NsHeaderProfile from "./NsHeaderProfile.vue";
import NsHeaderProfileToggle from "./NsHeaderProfileToggle.vue";

const PROFILE_CLOSED = "profileClosed";
export default {
  name: "NsHeaderProfileDropdown",
  components: {
    NsIcon,
    NsAnimateHeight,
    NsHeaderProfile,
    NsHeaderProfileToggle
  },
  props: {
    /**
     * Hides the Signup text and link
     */
    hideSignUp: Boolean,
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, enjoyLoyalty, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dropdownOpen: !SitesSessionStorageService.getItem(PROFILE_CLOSED)
  }),
  methods: {
    handleCloseClick() {
      this.$emit("close-drawer");
    },
    handleDropdownToggle() {
      this.dropdownOpen = !this.dropdownOpen;
      SitesSessionStorageService.removeItem(PROFILE_CLOSED);
      SitesSessionStorageService.writeItem(PROFILE_CLOSED, !this.dropdownOpen);
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use '~@nuskin/ns-core-styles/src/scss/typographyVariables';

.container,
.container * {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.container {
  border-radius: 0px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
}

.header {
  display: flex;
}

.closeButton {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  width: 60px;
  height: 60px;
  cursor: pointer;

  // nested for specificity
  .closeIcon {
    width: 14px;
    height: 14px;
    color: map.get(colors.$themeColors, color-interactive-7);
  }
}
</style>
